export default function Gallery() {
  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-plum-dark mb-10">
          Nos réalisations à Ostwald
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          <div className="rounded-2xl overflow-hidden bg-white border border-rose-100 aspect-[4/3]">
            <img
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/683295856408ce0d8c327b04742d3849.jpeg"
              alt="Réparation de fenêtre PVC à Ostwald, Bas-Rhin"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="rounded-2xl overflow-hidden bg-white border border-rose-100 aspect-[4/3]">
            <img
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/205ee43d3021086af956d85726b23011.jpeg"
              alt="Réglage crémone fenêtre aluminium à Ostwald"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="rounded-2xl overflow-hidden bg-white border border-rose-100 aspect-[4/3]">
            <img
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a5678743fe9ccf4d4061d6534d54e38d.jpeg"
              alt="Maison avec fenêtre réparée à Ostwald, Bas-Rhin"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}